export {default} from './CabEligibleBonusIndicator';
